/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the Shopping Bag page
    // check for wholesale account and show modal
    if (products.userRole == 'pro') {
      // trigger wholesale notification modal
      $('#wholesale-notification-modal').modal('show');
      $('.wc-proceed-to-checkout > .checkout-button').addClass('disabled').text('Wholesale Checkout Disabled').attr('href','/shopping-bag/');
    }

    // function for performing the AJAX request to get Professionals' information and creating the HTML template
    function getProfessionals(url, dataObj, security, action) {
      $.ajax({
        url,
        method: 'post',
        dataType: 'json',
        data: {'json': dataObj, 'security': security, 'action': action},
        success(response, textStatus, jqXhr) {
          if (response.status === 'success') {
            // declare the radius var
            const radius = parseInt( parseFloat( response.data.radius ) / 1609.34 );

            // adjust the height of the container since it starts out collapsed
            $('.shopping-bag__column--epionce-near-you').height(350);

            if (response.data.results > 0) {
              // Houston, we have Professional data

              // Start build the data rows
              let rows = ''; // for storing the HTML
              response.data.data.forEach((element, index) => {
                let connectButtonText = 'Connect';
                let connectedButtonClass = '';
                let connectButton = '';

                // only show Connect buttons if radius is 25 or less
                if (radius > 25) {
                  element.show_connect_button = false;
                }

                if (element.connected) {
                  connectButtonText = 'Saved';
                  connectedButtonClass = ' connected';
                  connectButton = `<div class="shopping-bag__column--epionce-near-you-connect"><a class="shopping-bag__epionce-near-you__connect-button${connectedButtonClass}" id="connect-button_${element.pro_code}" href="#">${connectButtonText}</a></div>`
                } else if (element.show_connect_button) {
                  connectButtonText = 'Connect';
                  connectButton = `<div class="shopping-bag__column--epionce-near-you-connect"><a class="shopping-bag__epionce-near-you__connect-button${connectedButtonClass}" id="connect-button_${element.pro_code}" href="#">${connectButtonText}</a></div>`
                } else {
                  connectButton = '<div class="shopping-bag__column--epionce-near-you-connect bold" style="text-align:center"><i class="far fa-phone"></i> Call for Info</div>'
                }

                rows += `<div class="shopping-bag__row--epionce-near-you-result"><div class="shopping-bag__column--epionce-near-you-distance"><p class="shopping-bag__epionce-near-you__distance">${element.distance} mi.</p></div><div class="shopping-bag__column--epionce-near-you-pro-info"><p class="shopping-bag__epionce-near-you__pro-name">${element.business_name}</p><address class="shopping-bag__epionce-near-you__pro-address">${element.address}<br>${element.city}, ${element.state} ${element.zipcode}</address><a class="shopping-bag__epionce-near-you__pro-phone-number" href="tel:${element.phone_number}">${element.phone_number}</a></div>${connectButton}</div>`;
              });

              // place in the view
              $('#find-nearby-pros-container').html(rows);

            } else {
              // no results found
              let noResultsHtml;
              if ( radius === 25 ) {
                // no results found using largest radius allowed for Connect buttons to be present
                noResultsHtml = '<div class="signup-section__row--no-margin">'+
                                  '<div class="signup-section__column--search-button-container">'+
                                    '<p class="signup-section__epionce-near-you__retry-text">Thank you for your interest in Epionce! Unfortunately, there is not a physician in your area retailing Epionce at this time. Talk to your skin care professional about bringing Epionce closer to you.<br>To extend your search area, <a id="find-nearby-pros-button" data-radius="150" href="#">click here</a></p>'+
                                  '</div>'+
                                '</div>';
              }

              if (radius === 150) {
                // no results found using largest radius allowed for Connect buttons to be present
                noResultsHtml = '<div class="signup-section__row--no-margin">'+
                                  '<div class="signup-section__column--search-button-container">'+
                                    '<p class="signup-section__epionce-near-you__retry-text">Thank you for your interest in Epionce! Unfortunately, there is not a physician in your area retailing Epionce at this time. Talk to your skin care professional about bringing Epionce closer to you.<br>To extend your search area, <a id="find-nearby-pros-button" data-radius="250" href="#">click here</a></p>'+
                                  '</div>'+
                                '</div>';
              }

              if (radius === 250) {
                // no results found using largest radius allowed for Connect buttons to be present
                noResultsHtml = '<div class="signup-section__row--no-margin">'+
                                  '<div class="signup-section__column--search-button-container">'+
                                    '<p class="signup-section__epionce-near-you__retry-text">Thank you for your ongoing interest in Epionce! Unfortunately, there is not a physician in your area retailing Epionce at this time. Talk to your skin care professional about bringing Epionce closer to you. Please contact us to be referred to an Epionce Professional that may be near you.<br><a href="/customer-service/" style="display:inline-block;margin-top:1rem;">Contact Us</a></p>'+
                                  '</div>'+
                                '</div>';
              }

              $('#find-nearby-pros-container').html(noResultsHtml);
            }


          } else {
            console.log("AJAX was successful, return status other than success...");
            console.log(textStatus);
          }
        },
        error(jqXhr, textStatus, errorThrown) {
          console.log(jqXhr);
          console.log(textStatus);
          console.log(errorThrown);
        }
      });
    }

    // function for handler a successful location watch call
    function geo_success(position) {

      // get the acquired coordinates
      // for testing with remote location
      // var lat = 39.4381245;
      // var lng = -116.9852422;
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      let radius = 25;
      if (typeof window.shoppingBagProSearchRadius !== 'undefined' && window.shoppingBagProSearchRadius !== null && window.shoppingBagProSearchRadius !== '') {
        radius = window.shoppingBagProSearchRadius;
      }

      // create the data obj to send to the server side
      const coord_obj = {
        lat,
        lng,
        radius
      };

      // perform the AJAX request to gather professionals data and build HTML professionals list template
      getProfessionals(epionce_near_you.ajaxUrl, coord_obj, epionce_near_you.nonce, 'find_professionals');
    }

    // function for handling a location watch call that has errors
    function geo_error(error) {
      let errorMessage = '';
      let primaryButtonText = '';
      let primaryButtonDataActionAttr = '';

      switch(error.code) {
        case error.PERMISSION_DENIED:
          errorMessage = 'You have blocked this site from accessing your location.';
          primaryButtonText = 'Learn How To Unblock Location Access';
          primaryButtonDataActionAttr = 'unblock_location';
          break;
        case error.POSITION_UNAVAILABLE:
          errorMessage = 'Your location information is currently unavailable. Please try again.';
          primaryButtonText = 'Try Again';
          primaryButtonDataActionAttr = 'try_again';
          break;
        case error.TIMEOUT:
          errorMessage = 'The request to get your location took too long. Please try again.';
          primaryButtonText = 'Try Again';
          primaryButtonDataActionAttr = 'try_again';
          break;
        case error.UNKNOWN_ERROR:
          errorMessage = 'An unknown error occurred while trying to access your location. Please try again.';
          primaryButtonText = 'Try Again';
          primaryButtonDataActionAttr = 'try_again';
          break;
      }

      // do something now that we know which error occurred
      const errorHtml = `<div class="signup-section__row--no-margin"><div class="<div class="signup-section__column--error-message-container"><p class="signup-section__epionce-near-you__error-message-text">${errorMessage}</p></div><div class="signup-section__column--error-button-container"><a class="signup-section__epionce-near-you__error-button" id="epionce-near-you-location-error-button" data-action="${primaryButtonDataActionAttr}" href="#">${primaryButtonText}</a></div></div>`;

      // place the location error message template
      $('#find-nearby-pros-container').html(errorHtml);
    }

    // function to locate nearby professionals
    function findNearbyProfessionals(radius) {

      window.shoppingBagProSearchRadius = radius;

      // kill any pre-existing watchIds
      if (typeof window.watchId !== 'undefined' && window.watchId !== null && window.watchId !== '') {
        navigator.geolocation.clearWatch(window.watchId);
      }

      const geo_options = {
        enableHighAccuracy: true,
        timeout: 30000,
        maximumAge: 3600000 // one hour in milliseconds
      };

      window.watchId = navigator.geolocation.watchPosition(geo_success, geo_error, geo_options);
    }

    // function to add tooltips to fields that need a small explanation about the input
    function addFieldTooltip(fieldId, message) {
      // get the field wrapper, which has position relative applied
      const $fieldWrapper = $(`#${fieldId}`).closest('div');

      // create the tooltip template
      const tooltipHtml = `<div class="signup-section__signup__tooltip"><a class="signup-section__signup__tooltip-close-button" id="tooltip-close-button" href="#" tabindex="-10"><i class="icon-custom-circle-plus-sign"></i></a><p class="signup-section__signup__tooltip-text">${message}</p></div>`;

      // add the tooltip to the DOM under the field
      $fieldWrapper.append(tooltipHtml);

      // activate the opacity of the tooltip
      setTimeout(() => {
        $fieldWrapper.find('.signup-section__signup__tooltip').addClass('active');
      },20);

      // disable the next button
      $('#next-prev-container').find('#next-arrow').prop('disabled', true).addClass('disabled');
    }

    // function to remove any tooltips from a field
    function removeFieldTooltip(fieldId) {
      const $fieldWrapper = $(`#${fieldId}`).closest('div');
      const $tooltip = $fieldWrapper.find('.signup-section__signup__tooltip');

      if ($tooltip.length) {
        // deactivate the opacity of the tooltip
        $tooltip.removeClass('active');

        // remove the tooltip
        setTimeout(() => {
          $tooltip.remove();
        },250);

        // reenable the next button
        $('#next-prev-container').find('#next-arrow').prop('disabled', false).removeClass('disabled');
      }
    }

    // function to save an inputted Professional Code
    function saveProfessionalCodeToUserAccount(professionalCode, saveButtonId, proCodeFieldId) {

      // give the button a spinner
      $(`#${saveButtonId}`).html('<i class="far fa-spinner fa-pulse"></i>');

      const $promise = $.ajax({
        url: epionce_near_you.ajaxUrl,
        method: 'post',
        dataType: 'json',
        data: {'json': {professionalCode}, 'security': epionce_near_you.nonce, 'action': 'saveProfessionalCodeToUserAccount'}
      });

      // fulfilled promise with success
      $promise.done((response, textStatus, jqXhr) => {

        if (response.status === 'fail') {
            $(`#${saveButtonId}`).html('Save');
            $(`#${proCodeFieldId}`).val('');
            $(`#${proCodeFieldId}`).attr('placeholder','Enter a valid Professional Code');
            alert(response.data.professionalCode);
        } else if (response.status === 'success') {
          if ($('.shopping-bag__already-connected__pro-code-input-label').html() == `Enter Your Professional's Code`) {
            $('.shopping-bag__already-connected__field-wrapper').replaceWith(`
            <div class="shopping-bag__already-connected__field-wrapper">
              <label class="shopping-bag__already-connected__pro-code-input-label" for="pro-code">Your Professional's Code: <span style="text-decoration: underline;">${response.data.professionalCode}</span></label>
                <a class="shopping-bag__already-connected__pro-code-input-show-link" id="show-pro-code-input" href="#">Click here to change your Code</a>
                <input class="shopping-bag__already-connected__pro-code-input" id="pro-code" type="text" placeholder="Enter a new professional code here" style="display:none">
                <button class="shopping-bag__already-connected__save-button" id="connect-save-button" style="display:none;">Save</button>
            </div>
            `);
          }

          $('.shopping-bag__already-connected__pro-code-input-show-link').on('click', function (e) {
            e.preventDefault();
            $('.shopping-bag__already-connected__pro-code-input').css('display', 'inline-block');
            $(this).remove();
            $('.shopping-bag__already-connected__pro-code-input').focus();
            $('.shopping-bag__already-connected__save-button').css('display','inline-block');
          });

          if ($('.shopping-bag__already-connected__pro-code-input').length) {
            $('.shopping-bag__already-connected__pro-code-input').on('keyup',function(e){
              const proCode =  $(this).val();
              const $connectSaveButton = $('#connect-save-button');

              // remove any tooltips that may be attached to this field
              removeFieldTooltip($(this).attr('id'));

              if (typeof proCode !== 'undefined' && proCode !== null && proCode !== '') {
                if (!$connectSaveButton.hasClass('isVisible')) {
                  $connectSaveButton.addClass('isVisible');
                }
              } else {
                $connectSaveButton.removeClass('isVisible');
              }
            });
          }

          // click handler for the professional code entry = button
          if ($('.shopping-bag__already-connected__save-button').length) {
            $('.shopping-bag__already-connected__save-button').on('click',e => {
              e.preventDefault();
              const $professionalCodeField = $('.shopping-bag__already-connected__pro-code-input');
              const professionalCode = $professionalCodeField.val();

              if ( typeof professionalCode !== 'undefined' && professionalCode !== null && professionalCode !== '' ) {
                // if it's a valid value, save it
                saveProfessionalCodeToUserAccount(professionalCode, 'connect-save-button', $professionalCodeField.attr('id'));
              } else {
                // it's an invalid value, display tooltip
                // first remove any existing tooltips
                removeFieldTooltip($professionalCodeField.attr('id'));

                // add the tooltip
                addFieldTooltip($professionalCodeField.attr('id'), 'Please enter a valid Professional Code');
              }
            });
          }

          $(`#${saveButtonId}`).html('Saved!');
          $('.shopping-bag__already-connected__pro-code-input-label span').html(response.data.professionalCode);
          $(document.body).trigger('update_checkout');

          setTimeout(() => {
            $(`#${proCodeFieldId}`).val('');
            $(`#${saveButtonId}`).removeClass('isVisible');

            // stagger the label change so the opacity transition has time to complete
            setTimeout(() => {
              $(`#${saveButtonId}`).html('Save');
              window.location.href = window.location.href.replace(window.location.search, '')
            },250);
          },2000);
        }
      });

      // fulfilled promise with error
      $promise.fail((jqXhr, textStatus, errorThrown) => {
        console.log(jqXhr);
        console.log(textStatus);
        console.log(errorThrown);
        $(`#${saveButtonId}`).html('Error...please try again');

        setTimeout(() => {
          $(`#${saveButtonId}`).html('Save');
        },2000);
      });
    }

    // function to connect a user to a pro via Connect button click
    function saveProfessionalCodeToUserAccount_buttonClick(buttonClass, clickedConnectButtonId) {
      // get the professional code from the button id
      const professionalCodeArray = clickedConnectButtonId.split('_');
      const professionalCode = professionalCodeArray[1];

      // give the button a spinner
      $(`#${clickedConnectButtonId}`).html('<i class="far fa-spinner fa-pulse"></i>');

      // create the AJAX promise
      const $promise = $.ajax({
        url: epionce_near_you.ajaxUrl,
        method: 'post',
        dataType: 'json',
        data: {'json': {professionalCode}, 'security': epionce_near_you.nonce, 'action': 'saveProfessionalCodeToUserAccount'}
      });

      // fulfilled promise with success
      $promise.done((response, textStatus, jqXhr) => {

        if (response.status === 'fail') {
          // find all Connect buttons, remove the connected class and replace text with Connect
          $(`.${buttonClass}`).each(function(i,e){
            $(this).removeClass('connected').html('Connect');
          });
          alert(response.data.professionalCode);
        } else if (response.status === 'success') {
          // find all Connect buttons, remove the connected class and replace text with Connect
          $(`.${buttonClass}`).each(function(i,e){
            $(this).removeClass('connected').html('Connect');
          });
          console.log($(document.body).trigger('update_checkout'));
          $(document.body).trigger('update_checkout');

          // add the connected class to the clicked button
          $(`#${clickedConnectButtonId}`).html('Connected').addClass('connected');
        }

      });

      // fulfilled promise with error
      $promise.fail((jqXhr, textStatus, errorThrown) => {
        console.log(jqXhr);
        console.log(textStatus);
        console.log(errorThrown);
        $(`#${clickedConnectButtonId}`).html('Try Again');

        setTimeout(() => {
          $(`#${clickedConnectButtonId}`).html('Connect');
        },2000);
      });
    }

    if ($('#find-nearby-pros-container').length) {

      $('#show-pro-code-input').on('click', function (e) {
        e.preventDefault();
        $('#pro-code').css('display', 'inline-block');
        $(this).remove();
        $('#pro-code').focus();
        $('#connect-save-button').css('display','inline-block');
      });

      // delegated click handler for the Find Nearby Professionals button in the sidebar
      $('#find-nearby-pros-container').on('click','#find-nearby-pros-button',function(e){
        e.preventDefault();
        const $button = $(this);
        $button.html('<i class="far fa-spinner fa-pulse"></i>');
        let radius = 25;
        if ($button.attr('data-radius')) {
          radius = parseInt( $button.attr('data-radius') );
        }
        findNearbyProfessionals(radius);
      });

      // delegated click handler for the error message button
      $('#find-nearby-pros-container').on('click','#epionce-near-you-location-error-button',e => {
        e.preventDefault();

        const target = e.target || e.srcElement;
        const $target = $(target);

        const clickAction = $target.attr('data-action');
        const radius = 25;

        if (clickAction === 'try_again') {
          findNearbyProfessionals(radius);
        } else if (clickAction === 'unblock_location') {
          $('#unblockLocationAccessModal').modal({"show":true});
        }
      });

      // delegated click handler for the Connect buttons in the Find Professionals widget
      $('#find-nearby-pros-container').on('click', '.shopping-bag__epionce-near-you__connect-button', e => {
        e.preventDefault();

        const target = e.target || e.srcElement;

        // get the button id
        const buttonId = $(target).attr('id');

        // save the pro code to the users account or user preferences session entry
        saveProfessionalCodeToUserAccount_buttonClick('shopping-bag__epionce-near-you__connect-button', buttonId);
      });
    }

    // keyup handler for the professional code entry field
    if ($('#pro-code').length) {
      $('#pro-code').on('keyup',function(e){
        const proCode =  $(this).val();
        const $connectSaveButton = $('#connect-save-button');

        // remove any tooltips that may be attached to this field
        removeFieldTooltip($(this).attr('id'));

        if (typeof proCode !== 'undefined' && proCode !== null && proCode !== '') {
          if (!$connectSaveButton.hasClass('isVisible')) {
            $connectSaveButton.addClass('isVisible');
          }
        } else {
          $connectSaveButton.removeClass('isVisible');
        }
      });
    }

    // click handler for the professional code entry = button
    if ($('#connect-save-button').length) {
      $('#connect-save-button').on('click',e => {
        e.preventDefault();
        const $professionalCodeField = $('#pro-code');
        const professionalCode = $professionalCodeField.val();

        if ( typeof professionalCode !== 'undefined' && professionalCode !== null && professionalCode !== '' ) {
          // if it's a valid value, save it
          saveProfessionalCodeToUserAccount(professionalCode, 'connect-save-button', $professionalCodeField.attr('id'));
        } else {
          // it's an invalid value, display tooltip
          // first remove any existing tooltips
          removeFieldTooltip($professionalCodeField.attr('id'));

          // add the tooltip
          addFieldTooltip($professionalCodeField.attr('id'), 'Please enter a valid Professional Code');
        }
      });
    }
  },
  finalize() {
    // JavaScript to be fired on the Shopping Bag page, after the init JS

    // Disable quantity input select box if it's a free item
    $('.shopping-bag__table__item').each(function (i, e) {
      if ( $(this).attr('data-free-product') === '1' ) {
        quantityInput = $(this).find('input');
        quantity = quantityInput.val();
        quantityInput.remove();
        quantityContainer = $(this).find('.quantity');
        quantityContainer.css("text-align", "center");
        quantityContainer.append(`<span>${quantity}</span>`);
      }
    });

    // if we are checking out a Professional/Wholesale account, adjust the Free Items, if appl
    if ( products.userRole === 'pro' ) {

      // get the one that has a variation of "Free Item"
      let freeItemQuantity = null;
      $('.shopping-bag__table__item__name.product-name').find('dd.variation-Type > p').each((i, e) => {
        if ( $(e).text() === 'Free Item' ) {
          $(e).closest('.shopping-bag__table__item__name.product-name').prev().find('.attachment-shop_thumbnail').remove();
          freeItemQuantity = $(e).closest('.shopping-bag__table__item__name.product-name').next().next();
        }
      });

      let totalQuantity = 0;
      $('.shopping-bag__table__item__quantity.product-quantity > .quantity > .input-text.qty.text').each((i, e) => {
        if ($(e).closest('.shopping-bag__table__item__quantity.product-quantity').prev().prev().find('dd.variation-Type > p').text() !== 'Free Item') {
          totalQuantity += parseInt($(e).val());
        }
      }).promise().done(() => {
        if (freeItemQuantity) {
          freeItemQuantity.text(totalQuantity);
        }
      });
    } else {
      $('.shopping-bag__table__item__name.product-name').find('dd.variation-Type > p').each((i, e) => {
        if ( $(e).text() === 'Free Item' ) {
          $(e).closest('.shopping-bag__table__item__name.product-name').prev().find('.attachment-shop_thumbnail').remove();
        }
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/shoppingBag.js